import { createFileRoute } from "@tanstack/react-router";
import { LabsHome } from "~/components/labs/LabsExperience";
import { loadAllEngineeringPosts } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/labs/")({
  loader: () => loadAllEngineeringPosts(),
  head: () => ({
    meta: seo({
      title: "C1 Labs | Identity security research",
      description: "C1 Labs publishes identity-security research and hands-on exercises for the age of autonomous agents.",
      url: "/labs",
    }),
    links: seoLinks({ url: "/labs" }),
  }),
  component: LabsIndex,
});

function LabsIndex() {
  return <LabsHome posts={Route.useLoaderData()} />;
}
